<template>
    <div class="contact-question row" :class="{'on-viewport': visibility}" style="margin-top: 65px;">
        <div class="col-md-12 d-flex flex-column align-items-center mb-5">
            <h4 class="title-28 mb-3 weight-600">{{$t("home.contact.speak_with_us")}}!</h4>
            <p class="size-18 color-dark-gray-400 weight-300 text-center" style="max-width: 750px;">{{$t("home.contact.description_speak_with_us")}}</p>
        </div>
        <div class="col-12 mt-2">
            <!-- the semi-circle background -->
            <div class="position-absolute w-100" style="left: 0; z-index: 1;">
                <div class="position-relative">
                    <div class="semi-circle-bg position-absolute w-100" />
                </div>
            </div>
            <!---->
            <div :key="vidvie" class="row mx-0 mx-lg-0 cards-container justify-content-center justify-content-lg-between position-relative" style="left: 0; z-index: 2;">
                <div class="card-height-container d-flex justify-content-center align-items-start px-0" v-for="item in verifyUSTECH() ? items_us : items" :key="item.title">
                    <card class="mx-0" @click.native="dynamic_function_handler(item.event)">
                        <div class="d-flex flex-column align-items-center justify-content-start position-relative" style="height: 150px;">
                            <component :is="item.icon" :size="item.size" :color="'var(--main-navy)'" style="height: 100px;"></component>
                            <span class="text-center" style="max-width: 300px; margin-top: 10px;">{{$t(`home.${verifyUSTECH() ? 'contact_us' : 'contact'}.` + item.title)}}</span>
                            <p class="weight-300 color-dark-gray-200 position-absolute text-center mb-0">{{$t(item.description)}}</p>
                        </div>
                    </card>
                </div>
                <template v-if="!verifyUSTECH()">
                    <div class="card-height-container d-flex justify-content-center align-items-start px-0" v-for="itemIntercom in itemIntercom" :key="itemIntercom.title">
                        <card class="mx-0" @click.native="openIntercom()">
                            <div class="d-flex flex-column align-items-center justify-content-start position-relative" style="height: 150px;">
                                <component :is="itemIntercom.icon" :size="itemIntercom.size" :color="'var(--main-navy)'" style="height: 100px;"></component>
                                <span class="text-center" style="max-width: 300px; margin-top: 10px;">{{$t(`home.${verifyUSTECH() ? 'contact_us' : 'contact'}.` + itemIntercom.title)}}</span>
                                <p class="weight-300 color-dark-gray-200 position-absolute text-center mb-0">{{$t(itemIntercom.description)}}</p>
                            </div>
                        </card>
                    </div>
                </template>
            </div>
    </div>
    <follow-us v-if="follow" @closeModal="follow = false" :product="shareProduct"/>
    </div>
</template> 

<script>
import FollowUs from '@/modules/home/components/contact/modals/FollowUs.vue'
import Card from '../../../../common/components/cards/Card.vue'
import IconChat from '../../../../common/svg/iconChat.vue'
import IconPhone from '../../../../common/svg/iconPhone.vue'
import IconShare from '../../../../common/svg/iconShare.vue'
import IconEmail from '../../../auth/assets/svg/iconEmail.vue'
import iconCalendar from '../../../../common/svg/iconCalendar.vue'
import { mapGetters } from 'vuex'
export default {
    components: { Card, IconPhone, IconEmail, IconChat, IconShare, FollowUs, iconCalendar},
    name: "contactOptions",
    props: {
        visibility: {
            type: Boolean,
            // default: true,
        }
    },
    computed:{
        ...mapGetters({
            vidvie: "home/vidvie"
        })
    },
    methods:{
        //to handle the differect actions on the v-for
        dynamic_function_handler(function_name){
            this[function_name]();
        },
        customerSupportAction(){
            this.$copyText( this.verifyUSTECH() ? '2015157659' : '8095817666')
        },
        openSocialMediaModalAction(){
            this.follow = true
        },
        sendToEmailAction(){
            window.open(`mailto:${this.verifyUSTECH() ? 'info@vidvie.com' : 'info@mundomovil.com.do'}?&subject=Tu%20asunto`)
        },
        openIntercom(){
            this.$intercom.show()
        }
    },
    data() {
        return {
            follow: false,
            items: [
                {title: 'customer_support', description: `home.contact.customer_service_desc`, icon: 'icon-phone', size: 45, event:'customerSupportAction' }, //events are function names
                {title: 'email', description: `home.contact.email_desc`, icon: 'icon-email', size: 60, event:'sendToEmailAction'},
                {title: 'follow_us_on_the_networks', description: "home.contact.share_desc", icon: 'icon-share', size: 50, event:'openSocialMediaModalAction'}, 
            ],
            items_us: [
                {title: 'customer_support', description: `home.contact_us.customer_service_desc`, icon: 'icon-phone', size: 45, event:'customerSupportAction' }, //events are function names
                {title: 'email', description: `home.contact_us.email_desc`, icon: 'icon-email', size: 60, event:'sendToEmailAction'},
                {title: 'follow_us_on_the_networks', description: "home.contact.share_desc", icon: 'icon-share', size: 50, event:'openSocialMediaModalAction'},
                {title: 'business_hours', description: "Monday - Saturday: 09:00 - 19:00 Sunday: Closed", icon: 'icon-calendar', size: 50, event:''}, 
            ],
            itemIntercom: [{title: 'chat_with_us', description: "home.contact.chat_desc", icon: 'icon-chat', size: 65},],
            shareProduct: {"reviews":[{"rated":4,"user_id":0,"title":"Good Purchase","comment":"","full_name":"","images":[]},{"rated":4,"user_id":0,"title":"Good Purchase","comment":"","full_name":"","images":[]}],"reference":[],"quantity":0,"imageGallery":[{"0":"5fddf94aSin título-1.jpg","1":"normal","picture":"5fddf94aSin título-1.jpg","photo_type":"normal","picture_url":"https://erp-dh.s3.amazonaws.com/mm_dev/img/Products/5fddf94aSin%20t%C3%ADtulo-1.jpg?AWSAccessKeyId=ASIAYGNBNJY3BB3VKEFS&Expires=1650038601&Signature=cdt0DWECbHSXFtznPyA5R1PynKM%3D&x-amz-security-token=IQoJb3JpZ2luX2VjEPj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMSJHMEUCIQCN2WouX4EFMGVZfCayGZnbSr5DydflLgX6S1aIi4a0YgIgWebpwTNXzq1ADuS9N6B57igGKoPSo8kLGu6W5PdZtwEqgwQIkf%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARADGgw1NjM1MTYxMDAxNTAiDN%2FN8OYj5kOYH18GvirXAzwRnZz5rF0Yyl4qcpO%2BBo8vCD0GQwkZJ0Xu7NPkGOyvCC%2F38q%2F6JyXCVPp9JeNAOf8MppWHizCGV2wgAZ0BHLTBRWR13bkrz9KkWDusQLDZcypscvox30lt2%2BR6AkfxPqsvt4kw387jEVk6RQFARx1mP1NIyGvCn1kSogVqNR5OW3pQ4V1gHBAxSJkNodDelGR3BIYVr77ckKwiNuDiIsV60sUbonjloonHfKYoSsDWv16yK%2FM2ZkZmH9aVHEtKFsMnWS9OONrGA6Cx%2BLINbX8A6ILqUYdpJTd%2BLFQtijxfVNhoWRrDHjpfxslXUwZ76V5qlWv9UGKxPuQ2uNGQ%2FVIeA%2BPi%2B6yZHotNX%2FupH4wkqlN2DiGarTjhM%2FSTSc%2B%2BRpdy1cNpl%2BZWiTeNEMG1SHE01Cpedoy%2BaDWS7y1zcMm6WMN0wXkSI%2FHfTgPxmdFqkDOdiEqin3KkikFNWhRQRfy5YN94tBQ8Dua7C8VNsKuIL8sCWw%2F5t6FfjCulu57pioOMT96qbsCGF94vrhtpr9wKmwshau%2BVV783nplviKvd%2FG8uG64YreNF1r6v3RbQDfZ%2BLmv5vBUY5%2FmWsQ4ngpYXlNYO%2BlViPTMwxsZuKPpoxsFluicguDCCyLGSBjqlAdSmJ3Dv0oBbubGZicSum8%2BmuxvFiQo96em02Teojz4tjwf2gqIHCBByBcFh5Cj3zToibXfZ%2FMGrBkxWnPKxE57s2%2FXDqXy%2BXO%2FAb4GTJGIwv84mVIer6KaJ%2B631ENMEa7IY7fQzQ0qsICpY0K5Ce%2BGAMZEyuNF6k7cetqegV3eE5sodjQOpX0J67Hfz%2B6xIRQbhPQWed571iCqnq8H2X0GI959b0A%3D%3D"},{"0":"5fddf94a56521412.jpg","1":"normal","picture":"5fddf94a56521412.jpg","photo_type":"normal","picture_url":"https://erp-dh.s3.amazonaws.com/mm_dev/img/Products/5fddf94a56521412.jpg?AWSAccessKeyId=ASIAYGNBNJY3BB3VKEFS&Expires=1650038601&Signature=dsLa6MUf%2BwMzJlfngKhgI5AOa7k%3D&x-amz-security-token=IQoJb3JpZ2luX2VjEPj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLWVhc3QtMSJHMEUCIQCN2WouX4EFMGVZfCayGZnbSr5DydflLgX6S1aIi4a0YgIgWebpwTNXzq1ADuS9N6B57igGKoPSo8kLGu6W5PdZtwEqgwQIkf%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FARADGgw1NjM1MTYxMDAxNTAiDN%2FN8OYj5kOYH18GvirXAzwRnZz5rF0Yyl4qcpO%2BBo8vCD0GQwkZJ0Xu7NPkGOyvCC%2F38q%2F6JyXCVPp9JeNAOf8MppWHizCGV2wgAZ0BHLTBRWR13bkrz9KkWDusQLDZcypscvox30lt2%2BR6AkfxPqsvt4kw387jEVk6RQFARx1mP1NIyGvCn1kSogVqNR5OW3pQ4V1gHBAxSJkNodDelGR3BIYVr77ckKwiNuDiIsV60sUbonjloonHfKYoSsDWv16yK%2FM2ZkZmH9aVHEtKFsMnWS9OONrGA6Cx%2BLINbX8A6ILqUYdpJTd%2BLFQtijxfVNhoWRrDHjpfxslXUwZ76V5qlWv9UGKxPuQ2uNGQ%2FVIeA%2BPi%2B6yZHotNX%2FupH4wkqlN2DiGarTjhM%2FSTSc%2B%2BRpdy1cNpl%2BZWiTeNEMG1SHE01Cpedoy%2BaDWS7y1zcMm6WMN0wXkSI%2FHfTgPxmdFqkDOdiEqin3KkikFNWhRQRfy5YN94tBQ8Dua7C8VNsKuIL8sCWw%2F5t6FfjCulu57pioOMT96qbsCGF94vrhtpr9wKmwshau%2BVV783nplviKvd%2FG8uG64YreNF1r6v3RbQDfZ%2BLmv5vBUY5%2FmWsQ4ngpYXlNYO%2BlViPTMwxsZuKPpoxsFluicguDCCyLGSBjqlAdSmJ3Dv0oBbubGZicSum8%2BmuxvFiQo96em02Teojz4tjwf2gqIHCBByBcFh5Cj3zToibXfZ%2FMGrBkxWnPKxE57s2%2FXDqXy%2BXO%2FAb4GTJGIwv84mVIer6KaJ%2B631ENMEa7IY7fQzQ0qsICpY0K5Ce%2BGAMZEyuNF6k7cetqegV3eE5sodjQOpX0J67Hfz%2B6xIRQbhPQWed571iCqnq8H2X0GI959b0A%3D%3D"}],"branchesAvailable":[{"existencia":"0","pos_id":"13","codarticulo":"9243","description":"Sucursal utesa"},{"existencia":"2","pos_id":"26","codarticulo":"9243","description":"Herrera"},{"existencia":"0","pos_id":"35","codarticulo":"9243","description":" jose marti"},{"existencia":"39","pos_id":"1","codarticulo":"9243","description":"Almacen central"},{"existencia":"10","pos_id":"7","codarticulo":"9243","description":"Sucursal san luis"},{"existencia":"0","pos_id":"24","codarticulo":"9243","description":"Plaza central"},{"existencia":"2","pos_id":"2","codarticulo":"9243","description":"Sucursal el carmen"},{"existencia":"0","pos_id":"25","codarticulo":"9243","description":"Charles de gaulle"}],"_id":"624c684ad5d4950b804c5931","codarticulo":9243,"category":{"category_id":7,"category_name":"ACCESORIOS DE CELULARES"},"subcategory":{"sub_category_id":40,"sub_category_name":"POWER BANK"},"description":"POWER BANK VIDVIE PB733 10000 MAH","feacture":"<p class=\"MsoNormal\" style=\"mso-margin-bottom-alt:auto;background:white\"><span style=\"font-size:13.0pt;font-family:&quot;Calibri&quot;,sans-serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;Times New Roman&quot;;mso-hansi-theme-font:\nminor-latin;mso-bidi-theme-font:minor-latin;color:gray;mso-themecolor:background1;\nmso-themeshade:128;mso-fareast-language:ES-DO\">Modelo: PB733<o:p></o:p></span></p>\n\n<p class=\"MsoNormal\" style=\"mso-margin-bottom-alt:auto;background:white\"><span style=\"font-size:13.0pt;font-family:&quot;Calibri&quot;,sans-serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;Times New Roman&quot;;mso-hansi-theme-font:\nminor-latin;mso-bidi-theme-font:minor-latin;color:gray;mso-themecolor:background1;\nmso-themeshade:128;mso-fareast-language:ES-DO\">Capacidad: 10,000MAH<o:p></o:p></span></p>\n\n<p class=\"MsoNormal\" style=\"mso-margin-bottom-alt:auto;background:white\"><span style=\"font-size:13.0pt;font-family:&quot;Calibri&quot;,sans-serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;Times New Roman&quot;;mso-hansi-theme-font:\nminor-latin;mso-bidi-theme-font:minor-latin;color:gray;mso-themecolor:background1;\nmso-themeshade:128;mso-fareast-language:ES-DO\">Material:&nbsp;<o:p></o:p></span><span style=\"color: rgb(119, 119, 119); font-family: Rubik, Arial, Helvetica, sans-serif; font-size: 14px;\">Plastico</span></p>\n\n<p class=\"MsoNormal\" style=\"mso-margin-bottom-alt:auto;background:white\"><span style=\"font-size:13.0pt;font-family:&quot;Calibri&quot;,sans-serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;Times New Roman&quot;;mso-hansi-theme-font:\nminor-latin;mso-bidi-theme-font:minor-latin;color:gray;mso-themecolor:background1;\nmso-themeshade:128;mso-fareast-language:ES-DO\">Tamaño:&nbsp;<o:p></o:p></span><span style=\"color: rgb(119, 119, 119); font-family: Rubik, Arial, Helvetica, sans-serif; font-size: 14px;\">71 * 89 * 22mm</span></p>\n\n<p class=\"MsoNormal\" style=\"mso-margin-bottom-alt:auto;background:white\"><span style=\"font-size:13.0pt;font-family:&quot;Calibri&quot;,sans-serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;Times New Roman&quot;;mso-hansi-theme-font:\nminor-latin;mso-bidi-theme-font:minor-latin;color:gray;mso-themecolor:background1;\nmso-themeshade:128;mso-fareast-language:ES-DO\">Puerto USB: 2 puertos<o:p></o:p></span></p>\n\n<p class=\"MsoNormal\" style=\"mso-margin-bottom-alt:auto;background:white\"><span style=\"font-size:13.0pt;font-family:&quot;Calibri&quot;,sans-serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;Times New Roman&quot;;mso-hansi-theme-font:\nminor-latin;mso-bidi-theme-font:minor-latin;color:gray;mso-themecolor:background1;\nmso-themeshade:128;mso-fareast-language:ES-DO\">Entrada:&nbsp;<o:p></o:p></span><span style=\"color: rgb(119, 119, 119); font-family: Rubik, Arial, Helvetica, sans-serif; font-size: 14px;\">5V / 1.5A&nbsp; &nbsp;V8</span></p>\n\n<p class=\"MsoNormal\" style=\"mso-margin-bottom-alt:auto;background:white\"><span style=\"font-size:13.0pt;font-family:&quot;Calibri&quot;,sans-serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;Times New Roman&quot;;mso-hansi-theme-font:\nminor-latin;mso-bidi-theme-font:minor-latin;color:gray;mso-themecolor:background1;\nmso-themeshade:128;mso-fareast-language:ES-DO\">Salida:&nbsp;&nbsp;<o:p></o:p></span><span style=\"color: rgb(119, 119, 119); font-family: Rubik, Arial, Helvetica, sans-serif; font-size: 14px;\">5V / 1.5A</span></p>\n\n<p class=\"MsoNormal\" style=\"mso-margin-bottom-alt:auto;background:white\"><span style=\"font-size:13.0pt;font-family:&quot;Calibri&quot;,sans-serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;Times New Roman&quot;;mso-hansi-theme-font:\nminor-latin;mso-bidi-theme-font:minor-latin;color:gray;mso-themecolor:background1;\nmso-themeshade:128;mso-fareast-language:ES-DO\">Color: Blanco<o:p></o:p></span></p>","discountPercentage":7,"brand":"VIDVIE","activated":true,"status":"Nuevo","model":"PB733","quantityPicture":2,"garanty":90,"storage":null,"color":"N/A","creation":"2019-12-20T15:46:51.000Z","GlobalExistence":53,"type_id":1,"type_description":"PRODUCTO","__v":0,"createdAt":"2022-04-05T16:03:22.399Z","updatedAt":"2022-04-05T16:03:22.399Z","existence":10,"quantity_required_special_price":0,"start_date_special_price":null,"end_date_special_price":null,"special_price":0,"price":1056.01},}
    },
}
</script>
<style scoped>

/* animations */
    .contact-question > div > h4, .contact-question > div > p, .contact-question > div > .cards-container > .card-height-container, .semi-circle-bg{
        opacity: 0;
    }
    @keyframes slide-down-h4 {
        from {
            transform: translateY(10px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
    .contact-question.on-viewport > div > h4 {
        animation: slide-down-h4 500ms both var(--alt-ease-in-out) .15s;
    }
    @keyframes slide-down-p {
        from {
            transform: translateY(45px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
    .contact-question.on-viewport > div > p {
        animation: slide-down-p 500ms both var(--alt-ease-in-out) .15s;
    }
    @keyframes slide-down-card {
        from {
            transform: translateY(80px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
    .contact-question.on-viewport > div > .cards-container > .card-height-container{
        animation: slide-down-card 500ms both var(--alt-ease-in-out) .15s;
    }
    /* assigning their respective delay */
    
    .contact-question.on-viewport > div > .cards-container > .card-height-container:nth-child(2){
        animation-delay: .20s;
    }
    .contact-question.on-viewport > div > .cards-container > .card-height-container:nth-child(3){
        animation-delay: .25s;
    }
    .contact-question.on-viewport > div > .cards-container > .card-height-container:nth-child(4){
        animation-delay: .30s;
    }

    .contact-question.on-viewport > div > div > div .semi-circle-bg {
        animation: slide-down-bg 500ms both var(--alt-ease-in-out) .15s;
    }
    @keyframes slide-down-bg {
        from {
            transform: translateY(35px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    .card-height-container {
        width: 300px;
        height: 290px;
    }
    .card-container {
        width: 370px;
        padding: 28px 15px;
        transition: all .22s ease-in-out;
    }
    .card-container:hover, .card-container:active{
        padding-bottom: 80px;
    }
    .card-container > div > div > span {
        font-size: 21px;
        color: var(--dark-gray-200) ;
        transition: var(--transition-1);
    } 
    .card-container > div > div > p {
        opacity: 0;
        font-size: 13px;
        transform: scale(1.2);
        bottom: -35px;
        width: 78%;
    }
    .card-container > div > div > svg {
        transition: all .22s ease-in-out;
    }
    .card-container > div > div {
        transition: var(--transition-1)
    }
    .card-container:hover > div > div {
        transform: translateY(4px);
    }
    .card-container:hover > div > div > span {
        color: var(--dark-main-navy);
        text-shadow: 1px 0px 0px var(--dark-main-navy);
        transition: var(--transition-1);
    }
    .card-container:hover > div > div > p {
        opacity: 1;
        bottom: -50px;
    }
    .card-container:hover > div > div > svg {
        fill: var(--main-red);
        transform: scale(1.1) translateY(4px);
    }

    @media (min-width: 768px) {
        .card-height-container:nth-child(1), .card-height-container:nth-child(3) {
            margin-right: 50px;
        } 
        .card-container{
            width: 90%;
        }
        .card-container > div > div > p {
            font-size: 13px;
            transform: scale(1.2);
            bottom: -35px;
            width: 78%;
        }
        .card-container:hover > div > div > p {
            bottom: -50px;
        }
        .semi-circle-bg {
            background-image: url('../../assets/svg/circle-background.svg');
            background-size: 100%;
            background-repeat: no-repeat;
            height: 500px;
            top: 80px;
        }
    }
    @media (min-width: 992px) {
        .card-container {
            width: 100%;
        }
        .card-container > div > div > span {
            font-size: 18px;
        }
        .card-container > div > div > p {
            font-size: 12px;
            transform: scale(1.2);
            bottom: -15px;
            width: 90%;
        }
        .card-container:hover > div > div > p {
            bottom: -38px;
        }
        .card-container:hover {
            padding-bottom: 65px;
        }
        .card-height-container { 
            width: 220px;
        }
        .card-height-container:nth-child(1), .card-height-container:nth-child(3) {
            margin-right: 0px;
        }
        .semi-circle-bg {
            top: -10px;
        }
    }
    @media (min-width: 1200px) {
        .card-height-container {
            width: 260px;
        }
        .card-container:hover{
            padding-bottom: 70px;
        }
        .card-container > div > div > span {
            font-size: 20px;
        }
        .card-container > div > div > p {
            font-size: 15px;
            bottom: -30px;
            transform: scale(1.05);
        }
        .card-container:hover > div > div > p {
            bottom: -43px;
        }
        .semi-circle-bg{
            top: 5px;
        }
    }
    @media (min-width: 1400px) {
        .card-height-container {
            width: 260px;
        }
        .card-container > div > div > span {
            font-size: 20px;
        }
    } 
</style>